import { ColDef } from '@ag-grid-enterprise/all-modules'
import { AgGridColumnType, AgGridExportType, ExportedColDef, ExportedColGroupDef } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import buildIconHeaderTemplate from '@/grid/buildIconHeaderTemplate'
import { ModuleOperationGuard } from '@/api/operations/guards/module-operation-guard'

const grossingGridSamplePendingArchiveChildrenColumnDefs = () : (ColDef | ExportedColDef)[] => ([
    {
        headerName: i18n.tc('grossing.grid.sampleLabel'),
        field: 'samLabel',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 110,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('registry.requestGrid.subGrid.location'),
        field: 'topographicCode.description',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 110,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('global.sampleType'),
        field: 'sampleType.description',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 110,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('grossing.sidebar.grossingDate'),
        field: 'lastGrossingDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        width: 110,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('grossing.grid.lastGrossingResponsible'),
        colId: 'responsibleForLastGrossing.normalizedFullName',
        field: 'responsibleForLastGrossing.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 160,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('grid.hasAlarms'),
        headerTooltip: i18n.tc('grid.hasAlarms'),
        field: 'incidents',
        type: AgGridColumnType.INCIDENT,
        exportType: AgGridExportType.INTEGER,
        filter: false,
        hide: true,
        width: 55,
        headerComponentParams: {
            template: buildIconHeaderTemplate('far fa-exclamation-triangle')
        }
    },
    {
        headerName: i18n.tc('grid.attachments'),
        headerTooltip: i18n.tc('grid.attachments'),
        field: 'attachments',
        type: AgGridColumnType.ATTACHMENT_COUNT,
        exportType: AgGridExportType.INTEGER,
        headerComponentParams: {
            template: buildIconHeaderTemplate('far fa-paperclip')
        }
    }
])

export const grossingGridSamplePendingArchiveColumnDefs = (): (ColDef | ExportedColGroupDef)[] => ([
    { type: AgGridColumnType.CUSTOM_CHECKBOX },
    {
        headerName: i18n.tc('entities.sample.sample'),
        children: ModuleOperationGuard.canAccessBilling
            ? grossingGridSamplePendingArchiveChildrenColumnDefs().concat([{
                type: AgGridColumnType.HAS_UNAUTHORIZED_BILLABLE_CONCEPTS,
                exportType: AgGridExportType.BOOLEAN,
                field: 'hasUnauthorizedBillableConcepts',
                flex: 1,
                minWidth: 55
            }])
            : grossingGridSamplePendingArchiveChildrenColumnDefs()
    }
])
